import {Directive} from '@angular/core';

/**
 * Use this directive with {@link IziviaSlidesComponent}.
 *
 * Due to how Swiper.js integrate with Angular, usage must look like the following:
 * ```
 * <izivia-slides>
 *     <izivia-slide>
 *         <ng-template iziviaSlideTemplate>
 *             <!-- Slide 1 -->
 *         </ng-template>
 *     </izivia-slide>
 *
 *     <izivia-slide>
 *         <ng-template iziviaSlideTemplate>
 *             <!-- Slide 2 -->
 *         </ng-template>
 *     </izivia-slide>
 * </izivia-slides>
 * ```
 *
 * or by using `*ngFor`:
 *
 * ```
 * <izivia-slides>
 *     <izivia-slide *ngFor="let media of medias">
 *         <ng-template iziviaSlideTemplate>
 *             <!-- Slide content: {{media}} -->
 *         </ng-template>
 *     </izivia-slide>
 * </izivia-slides>
 * ```
 *
 * @see IziviaSlideDirective
 * @see IziviaSlidesComponent
 */
@Directive({
    selector: '[iziviaSlideTemplate]'
})
export class IziviaSlideTemplateDirective {
}
